import { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "utils/@reduxjs/toolkit";
import { adminTemplateState } from "../types/index";
import { initialState } from "./initialState";


export const sliceKey = "adminTemplateState";


export const AdminTemplateSlice = createSlice({
  name: sliceKey,
  initialState: initialState,
  reducers: {
    
    }})

export const { reducer, actions } = AdminTemplateSlice